import axios from "axios";
import jwt_decode, { JwtPayload } from "jwt-decode";
import { GcSessionInfo } from "@glamcorner/gc-types/generated/types";

const axiosApi = axios.create({
  baseURL: window.parent.location.origin,
  headers: {
    "Cache-Control": "no-cache",
  },
  timeout: 15000,
});

const getJWT = async () => {
  const jwt = localStorage.getItem("token");
  if (jwt) {
    const { exp } = jwt_decode<JwtPayload>(jwt);

    if (exp && exp * 1000 > Date.now()) {
      return jwt;
    }
  }

  // Add random cache buster number
  const response = await axiosApi.get<GcSessionInfo>(`/gcsession?_=${Math.random()}`);
  const newToken = response.data.token;
  localStorage.setItem("token", newToken);
  return newToken;
};

// Authorization for API endpoints with JWT token happens here
// Search keywords:
//    authentication
//    user
//    login
//    json web token
axiosApi.interceptors.request.use(async (config) => {
  if (config.url?.startsWith("/api") || config.url?.startsWith("/gc-api")) {
    const token = await getJWT();
    config.headers!.Authorization = token ? `Bearer ${token}` : "";
  }

  return config;
});

export default axiosApi;
